var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',[_vm._v(" Номинации ")]),_c('tricolor-line'),_c('div',{staticClass:"nominations__container"},_vm._l((_vm.setNomination),function(nomination,index){return _c('nomination',{key:`nominationCard${index}`,attrs:{"card":nomination}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }